export enum SortOrder {
    Ascending = 'Ascending',
    Descending = 'Descending',
    Latest = 'Latest',
    Oldest = 'Oldest'
  }